<perfect-scrollbar class="scrollbar">
  <app-side-layout class="d-block d-md-none mb-2"></app-side-layout>
  <app-wind-atmosphere
    *ngIf="blockToShow != 'hydrography' && blockToShow != 'waves'"
  ></app-wind-atmosphere>
  <app-hydrography
    *ngIf="blockToShow != 'waves' && blockToShow != 'windAtmosphere'"
  ></app-hydrography>
  <app-waves
    *ngIf="blockToShow != 'hydrography' && blockToShow != 'windAtmosphere'"
  ></app-waves>
</perfect-scrollbar>
